<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="toc" id="toc">
<h1 class="ctfm"><a class="page" id="pvi"></a><a class="page" id="pvii"></a>CONTENTS</h1>
<p class="toc"><a class="xref" href="#/chipacyga0007#intro">Introduction: Polish Chicago</a></p>
<p class="toc"><a class="xref" href="#/chipacyga0008#ch01"><b>1</b>   Meet Me at the Fair: Poland’s Fourth Partition</a></p>
<p class="toc"><a class="xref" href="#/chipacyga0009#ch02"><b>2</b>   Settling In: Creating Polonia’s Capital</a></p>
<p class="toc"><a class="xref" href="#/chipacyga0010#ch03"><b>3</b>   Living in Polish Chicago, 1880–1920</a></p>
<p class="toc"><a class="xref" href="#/chipacyga0011#ch04"><b>4</b>   World War One: A Turning Point</a></p>
<p class="toc"><a class="xref" href="#/chipacyga0012#ch05"><b>5</b>   Interwar Polonia: Years of Stress and Change</a></p>
<p class="toc"><a class="xref" href="#/chipacyga0013#ch06"><b>6</b>   Apocalypse Again: World War Two and Its Aftermath</a></p>
<p class="toc"><a class="xref" href="#/chipacyga0014#ch07"><b>7</b>   The Lost Struggle: Chicago’s Polonia, Communist Poland, and a Changing City</a></p>
<p class="toc"><a class="xref" href="#/chipacyga0015#ch08"><b>8</b>   A New Polonia</a></p>
<p class="tocbmf"><a class="xref" href="#/chipacyga0016#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chipacyga0017#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chipacyga0018#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-pacyga-0006.vue?ae43e342